<div class="flex gap-1" *ngIf="value && value.length > 0">
    <span class="key">{{key}}:</span>
    <span class="value">{{value}}</span>
</div>
